import { render } from "./AssistedEnrollmentStep1.vue?vue&type=template&id=61d54b14&scoped=true"
import script from "./AssistedEnrollmentStep1.vue?vue&type=script&lang=js"
export * from "./AssistedEnrollmentStep1.vue?vue&type=script&lang=js"

import "./AssistedEnrollmentStep1.vue?vue&type=style&index=0&id=61d54b14&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d54b14"]])

export default __exports__